import { render, staticRenderFns } from "./ItemService.vue?vue&type=template&id=19e84a21&scoped=true"
import script from "./ItemService.vue?vue&type=script&lang=js"
export * from "./ItemService.vue?vue&type=script&lang=js"
import style0 from "./ItemService.vue?vue&type=style&index=0&id=19e84a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e84a21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
